import Joi from 'joi';

export const esiFormSchema = Joi.object({
  is_esi: Joi.boolean()
    .required()
    .messages({
      "any.required": "ESI field is required.",
    }),
  
  esi_code: Joi.string()
  
  .pattern(/^\d{17}$/)  // Ensures exactly 17 numeric characters
  .custom((value, helpers) => {
    // Check if all characters are the same
    if (/^(\d)\1{16}$/.test(value)) {
      return helpers.error("any.invalid");
    }
    return value;
  })
    .required()
    .messages({
      "string.empty": "ESI Code is required.",
      "string.pattern.base": "ESI Code must be exactly 17 digits.",
      "any.required": "ESI Code is required.",
      "any.invalid": "ESI Code cannot contain all identical digits.",
    }),
  
  coverage_date: Joi.date()
  
    .required()
    .messages({
      "date.base": "Coverage Date must be a valid date.",
      "any.required": "Coverage Date is required.",
    }),
  
  employee_contribution: Joi.number()
  
  .required()
    .messages({
      "number.base": "Employee Contribution must be a number.",
      "number.min": "Employee Contribution cannot be negative.",
      "number.max": "Employee Contribution cannot exceed 100%.",
      "any.required": "Employee Contribution is required.",
    }),
  
  employer_contribution: Joi.number()
    .min(0)
    .max(100)
    .required()
    .messages({
      "number.base": "Employer Contribution must be a number.",
      "number.min": "Employer Contribution cannot be negative.",
      "number.max": "Employer Contribution cannot exceed 100%.",
      "any.required": "Employer Contribution is required.",
    }),
  
  esi_office: Joi.string()
  
  
    .max(100)
    .allow("")
    .messages({
      "string.empty": "ESI Office is required.",
      "string.max": "ESI Office must not exceed 100 characters.",
      "any.required": "ESI Office is required.",
    }),
  
  address: Joi.string()
   
  
    .max(200)
    .allow("")
    .messages({
      "string.empty": "Address is required.",
      "string.max": "Address must not exceed 200 characters.",
      "any.required": "Address is required.",
    }),
  
  city: Joi.string()
 
  
    .max(50)
    .allow("")
    .messages({
      "string.empty": "City is required.",
      "string.max": "City must not exceed 50 characters.",
      "any.required": "City is required.",
    }),
  
  state: Joi.number()
    .integer()
    .positive()
    .allow(null, "")  // Allow null or an empty string as input
    .custom((value) => {
      // Transform null to an empty string before validation
      return value === null ? "" : value;
    })
    
    .messages({
      "number.base": "State is required.",
      "number.integer": "State is required.",
      "number.positive": "State is required.",
      "any.required": "State is required.",
      "any.invalid": "State is required.",
    }),
  
  country: Joi.number()
  .integer()
  .positive()
 
   
    .allow("")
    .messages({
   
      "string.max": "Country must not exceed 50 characters.",
     
    }),
  
  pincode: Joi.string()
  
    .pattern(/^\d{6}$/)  // Ensures 6-digit numeric pincode
    .allow("")
    .messages({
      "string.pattern.base": "Pincode must be exactly 6 digits.",
    }),
  
  location: Joi.string()
  
    .max(100)
    .allow("")
    .messages({
      "string.empty": "Location is required.",
      "string.max": "Location must not exceed 100 characters.",
      "any.required": "Location is required.",
    }),
  
  is_including_employee_ctc: Joi.boolean()
    .required()
    .messages({
      "any.required": "Including in Employee CTC field is required.",
    }),
});
